import { PATHS } from '../config';
import { dynoapeAPI } from '../dynoape';
import type {
    ShiftGeneratorTask,
    ShiftGeneratorTaskParams,
    ShiftGeneratorTasksResponse,
    TaskPatch,
} from './Models';

const getShiftGeneratorTask = async (
    departmentId: string,
    taskId: string,
    params?: ShiftGeneratorTaskParams,
): Promise<ShiftGeneratorTask> =>
    await dynoapeAPI.get(PATHS.task(departmentId, taskId, params));

const getShiftGeneratorTasks = async (
    departmentId: string,
): Promise<ShiftGeneratorTask[]> => {
    const response: ShiftGeneratorTasksResponse | undefined =
        await dynoapeAPI.get(PATHS.tasks(departmentId));
    return response?.elements ?? [];
};

const createTask = async (
    departmentId: string,
    task: ShiftGeneratorTask,
): Promise<ShiftGeneratorTask> =>
    await dynoapeAPI.post(PATHS.taskCreate(departmentId), task);

const patchTask = async (
    departmentId: string,
    taskId: string,
    patch: TaskPatch,
    params?: ShiftGeneratorTaskParams,
): Promise<ShiftGeneratorTask> =>
    await dynoapeAPI.patch(PATHS.task(departmentId, taskId, params), patch);

const deleteTask = async (
    departmentId: string,
    taskId: string,
): Promise<true> =>
    (await dynoapeAPI.delete(PATHS.task(departmentId, taskId))) ?? true;

/*
 * Triggers the external runner for the given tasks. The generation
 * runs asynchronously — the results change when it finishes, not
 * here.
 */
const executeTasks = async (
    orgId: string,
    taskIds: string[],
): Promise<unknown> =>
    await dynoapeAPI.put(PATHS.runnerExecute(orgId), { ids: taskIds });

const ShiftGeneratorTaskService = {
    getShiftGeneratorTask,
    getShiftGeneratorTasks,
    createTask,
    patchTask,
    deleteTask,
    executeTasks,
};

export default ShiftGeneratorTaskService;
